export const initCompanyProfileRoutes = (config: any, enabled: boolean = true) =>
    !enabled
        ? []
        : [
            {
                path: "/manage/company-profile",
                name: "company-profile",
                component: () => import("@/pages/manage/companyprofiles/index.vue"),
                meta: {
                    requiresAuth: true,
                    roles: [config.roles.administrators, config.roles.siteEditors],
                },
            },
            {
                path: "/manage/company-profile/:id",
                name: "companyProfile-id",
                component: () => import("@/pages/manage/companyprofiles/id.vue"),
                meta: {
                    requiresAuth: true,
                    roles: [config.roles.administrators, config.roles.siteEditors],
                },
            },
        ];
